<script setup>
defineProps({
  favorite: Boolean,
})
</script>

<template>
  <DIcon
    path="star"
    class="cursor-pointer"
    :class="{
      'text-yellow-400': favorite,
      'text-grey-100 hover:text-yellow-400': !favorite,
    }"
  />
</template>
